// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BarChartReport_wrap__1pDmL","wrapMobile":"BarChartReport_wrapMobile__2eB_E"};